export default __webpack_public_path__ + "static/media/unlink.63d82fba.svg";